import evaluationExamination from '@/api/academic/evaluation-examination';

import { baseState, baseMutations } from '@/store/mixins';
// import { join, split } from 'lodash';
import { split } from 'lodash';
import moment from "moment";

export const state = {
    ...baseState,
    formViewDatas: [],
    dateRange: [
        moment()
            .add(-7, "days")
            .format("DD-MM-YYYY"),
        moment().format("DD-MM-YYYY")
    ],
}
export const mutations = {
    ...baseMutations,
    SET_DATE_RANGE(state, date) {
        state.dateRange = date;
    },
    SET_VIEW_MODELS(state, { data, index }) {
        if (!index) {
            state.formViewDatas = data;
        } else {
            split(index, ",").forEach(el => {
                state.formViewDatas[el] = data[el];
            });
        }
    }
}
export const getters = {}

export const actions = {
    fetch(context, attrubutes = {}) {
        let params = Object.assign(
            {
                page: context.state.pagination.page,
                perPage: context.state.pagination.perPage,
                filter: {
                    search: context.state.search,
                    // date_between: join(context.state.dateRange, ","),
                }
            },
            attrubutes
        )
        return evaluationExamination.get({ params }).then(response => {
            context.commit('RECEIVE_RESOURCES', response)
            return Promise.resolve(response)
        })
    },
    update(context, data) {
        return evaluationExamination.update(data)
    },
    displayUpdate(context, data) {
        return evaluationExamination.displayUpdate(data)
    },
    store(context, data) {
        return evaluationExamination.store(data)
    },
    destroy(context, id) {
        return evaluationExamination.destroy(id)
    },
    async getFormViewData(context, { params, index }) {
        let response = await evaluationExamination.formModel({ params: params });
        context.commit("SET_VIEW_MODELS", {
            data: response.data,
            index: index
        });
        return Promise.resolve(response);
    },
}
